export default {
        API_URL: 'https://api.abekus.ai',
        JOBS_BASE_URL: 'https://abekus.ai',
        ROLLBAR_ACCESS_TOKEN: 'c0ab29feac904148846c6bd0f5d7dfe4',
        ENV: 'production',
        LEARNING_AUTO_LOGIN_URL: 'https://abekus.ai',
        RAZORPAY_KEY: '',
        IS_TEST: false,
        DATADOG_RUM_APPLICATION_ID: 'b947a461-4d20-49f3-a1a9-9951ad0481f5',
        DATADOG_RUM_CLIENT_TOKEN: 'pub5df053139fa05dd08ea43dc5a4e8ecff',
	DATADOG_API_KEY: '239e63bbebd02e8a1df5a3c93dd2a31f'
};
